// extracted by mini-css-extract-plugin
export default {"HeaderInitial":"Header_HeaderInitial__uNLkX","HeaderTitle":"Header_HeaderTitle__yLC1u"};